export default __webpack_public_path__ + "static/washer_b.3fbbb8ed5300f68c4cee998a589e75af.svg";